module.exports = __webpack_public_path__ + "static/KneeAnkleMed-26cf93be564feebe21a7ba246e14704d.jpg";